/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Send from './Send';

/**
 * The InlineResponse2006 model module.
 * @module model/InlineResponse2006
 * @version 1.0
 */
class InlineResponse2006 {
    /**
     * Constructs a new <code>InlineResponse2006</code>.
     * @alias module:model/InlineResponse2006
     */
    constructor() { 
        
        InlineResponse2006.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse2006</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse2006} obj Optional instance to populate.
     * @return {module:model/InlineResponse2006} The populated <code>InlineResponse2006</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse2006();

            if (data.hasOwnProperty('current_page')) {
                obj['current_page'] = ApiClient.convertToType(data['current_page'], 'Number');
            }
            if (data.hasOwnProperty('data')) {
                obj['data'] = ApiClient.convertToType(data['data'], [Send]);
            }
            if (data.hasOwnProperty('first_page_url')) {
                obj['first_page_url'] = ApiClient.convertToType(data['first_page_url'], 'String');
            }
            if (data.hasOwnProperty('from')) {
                obj['from'] = ApiClient.convertToType(data['from'], 'Number');
            }
            if (data.hasOwnProperty('last_page')) {
                obj['last_page'] = ApiClient.convertToType(data['last_page'], 'Number');
            }
            if (data.hasOwnProperty('last_page_url')) {
                obj['last_page_url'] = ApiClient.convertToType(data['last_page_url'], 'String');
            }
            if (data.hasOwnProperty('next_page_url')) {
                obj['next_page_url'] = ApiClient.convertToType(data['next_page_url'], 'String');
            }
            if (data.hasOwnProperty('path')) {
                obj['path'] = ApiClient.convertToType(data['path'], 'String');
            }
            if (data.hasOwnProperty('per_page')) {
                obj['per_page'] = ApiClient.convertToType(data['per_page'], 'Number');
            }
            if (data.hasOwnProperty('prev_page_url')) {
                obj['prev_page_url'] = ApiClient.convertToType(data['prev_page_url'], 'String');
            }
            if (data.hasOwnProperty('to')) {
                obj['to'] = ApiClient.convertToType(data['to'], 'Number');
            }
            if (data.hasOwnProperty('total')) {
                obj['total'] = ApiClient.convertToType(data['total'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} current_page
 */
InlineResponse2006.prototype['current_page'] = undefined;

/**
 * @member {Array.<module:model/Send>} data
 */
InlineResponse2006.prototype['data'] = undefined;

/**
 * @member {String} first_page_url
 */
InlineResponse2006.prototype['first_page_url'] = undefined;

/**
 * @member {Number} from
 */
InlineResponse2006.prototype['from'] = undefined;

/**
 * @member {Number} last_page
 */
InlineResponse2006.prototype['last_page'] = undefined;

/**
 * @member {String} last_page_url
 */
InlineResponse2006.prototype['last_page_url'] = undefined;

/**
 * @member {String} next_page_url
 */
InlineResponse2006.prototype['next_page_url'] = undefined;

/**
 * @member {String} path
 */
InlineResponse2006.prototype['path'] = undefined;

/**
 * @member {Number} per_page
 */
InlineResponse2006.prototype['per_page'] = undefined;

/**
 * @member {String} prev_page_url
 */
InlineResponse2006.prototype['prev_page_url'] = undefined;

/**
 * @member {Number} to
 */
InlineResponse2006.prototype['to'] = undefined;

/**
 * @member {Number} total
 */
InlineResponse2006.prototype['total'] = undefined;






export default InlineResponse2006;

